import type { HomeScope } from '@UI/Pages/Home/Signals/homeScopeSignal';
import type { ComposedOrganization } from '@UI/Providers/CurrentOrganizationProvider/helpers/composeAssignedOrganizations';

export type ScopeCoverage = {
	readonly organizationCount: number;
	readonly facilityCount: number;
};

/** Organizations (holding at least one agency) and agencies the selected scope covers. */
const countScopeCoverage = (
	organizations: readonly ComposedOrganization[],
	scope: HomeScope,
): ScopeCoverage => {
	const populated = organizations.filter((organization) => organization.facilities.length > 0);

	if (scope.kind === 'organization') {
		const organization = populated.find((candidate) => candidate.id === scope.id);

		return {
			organizationCount: organization ? 1 : 0,
			facilityCount: organization?.facilities.length ?? 0,
		};
	}

	if (scope.kind === 'facility') {
		return { organizationCount: 1, facilityCount: 1 };
	}

	return {
		organizationCount: populated.length,
		facilityCount: populated.reduce((total, organization) => total + organization.facilities.length, 0),
	};
};

export default countScopeCoverage;
